module.exports = __webpack_public_path__ + "img/c.97f6c25c.jpg";